import { render, staticRenderFns } from "./AccentButton.vue?vue&type=template&id=0216b95e&scoped=true"
import script from "./AccentButton.vue?vue&type=script&lang=js"
export * from "./AccentButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0216b95e",
  null
  
)

export default component.exports